"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Toast component - notification toast
 */
const react_1 = require("react");
/**
 * Toast component for displaying notifications
 * @param props - ToastProps
 * @returns Toast component
 */
const Toast = ({ id, type, message, duration = 5000, onDismiss, }) => {
    (0, react_1.useEffect)(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onDismiss(id);
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [id, duration, onDismiss]);
    const toastClasses = ['toast', `toast--${type}`].join(' ');
    const getIcon = () => {
        switch (type) {
            case 'success':
                return '✓';
            case 'error':
                return '✕';
            case 'warning':
                return '⚠';
            case 'info':
                return 'ℹ';
            default:
                return '';
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: toastClasses, role: "alert", "aria-live": type === 'error' ? 'assertive' : 'polite', children: [(0, jsx_runtime_1.jsx)("span", { className: "toast__icon", "aria-hidden": "true", children: getIcon() }), (0, jsx_runtime_1.jsx)("span", { className: "toast__message", children: message }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "toast__close", onClick: () => onDismiss(id), "aria-label": "Dismiss notification", children: "\u00D7" })] }));
};
exports.Toast = Toast;
exports.default = exports.Toast;
